import { getConsentFromCookieList } from './consent';
/**
 * its timeout for page load, yes it will skip later user consent set,
 * but it will work on next page
 */
var TIME_TO_TIMEOUT = 2000;
function isRedirectPage() {
    return window.document.location.href.startsWith('https://www.seznam.cz/nastaveni-souhlasu');
}
/**
 * SID storing checker.
 * Uses Promise
 */
export var sidLegalStoreCheckPromise = function () {
    return new Promise(function (resolveConsent) {
        if (isRedirectPage()) {
            window.addEventListener('scmp_closed', function (event) {
                resolveConsent(event.detail.purposeConsents.has(1));
            });
        }
        else {
            var timer_1 = window.setTimeout(function () {
                resolveConsent(false);
            }, TIME_TO_TIMEOUT);
            var consentCallback = function (consentResult) {
                if (consentResult) {
                    resolveConsent(consentResult.purposeOne);
                    if (timer_1) {
                        window.clearTimeout(timer_1);
                        timer_1 = null;
                    }
                }
            };
            consentCallback(getConsentFromCookieList(consentCallback));
        }
    });
};
/**
 * SID storing checker.
 * Uses callback
 * @param callbackOk called when sid CAN be legally stored
 * @param callbackNotOk called when sid CANNOT be legally stored
 */
export var sidLegalStoreCheck = function (callbackOk, callbackNotOk) {
    // callback runner
    var call = function (fn) {
        if (typeof fn === 'function') {
            fn();
        }
    };
    // legality checker
    var check = function (purposeOne) {
        call(purposeOne ? callbackOk : callbackNotOk);
    };
    if (isRedirectPage()) {
        window.addEventListener('scmp_closed', function (event) {
            check(event.detail.purposeConsents.has(1));
        });
    }
    else {
        var timer_2 = window.setTimeout(function () {
            check(false);
        }, TIME_TO_TIMEOUT);
        var consentCallback = function (consentResult) {
            if (consentResult) {
                check(consentResult.purposeOne);
                if (timer_2) {
                    window.clearTimeout(timer_2);
                    timer_2 = null;
                }
            }
        };
        consentCallback(getConsentFromCookieList(consentCallback));
    }
};
